<highcharts-chart *ngIf="data.length > 0"
    [Highcharts]="Highcharts"
    [options]="chartOptions"
    (chartInstance)="chartInstance = $event"
     [style.display]="data.length > 0 ? 'block' : 'none' "
    style="width: 100%; display: block;">
</highcharts-chart>
<app-loader *ngIf="loading"></app-loader>
<app-no-widget-data *ngIf="!loading && !data.length" class="wide-container" [svgSrc]="noDataView"></app-no-widget-data>
